<div class="proposals-actions-card" *ngIf="proposalsByOrder" [class.light]="orderHasProposals">
  <div class="grid no-padding">
    <div class="row">
      <div class="col no-padding" size="12">
        <div class="proposals-actions-card__info" (click)="onActionClicked(ACTIONS.EDIT)">
          <p class="proposals-actions-card__info__title">
            {{ 'MANAGE_VACATIONS.PROPOSAL' | translate }} {{ proposalsByOrder.order }}
            {{ 'MANAGE_VACATIONS.' + season | uppercase | translate | lowercase }}
          </p>
          <i class="app-icon-arrow-right"></i>
          <p
            class="proposals-actions-card__info__date"
            *ngFor="let item of proposalsByOrder.proposals; trackBy: trackByItems">
            {{ item.description }}
          </p>
          <p class="proposals-actions-card__info__empty" *ngIf="!orderHasProposals">
            {{ 'MANAGE_VACATIONS.VACATIONS_ASSIGNED_BY_COORDINATOR' | translate }}
          </p>
        </div>

        <hr />

        <app-icon-button
          buttonIcon="assets/imgs/icons/bin.svg"
          [buttonText]="'EMPLOYEE_PORTAL.DELETE' | translate"
          buttonType="icon"
          (buttonClicked)="onActionClicked(ACTIONS.DELETE)"
          *ngIf="orderHasProposals; else emptyProposals">
        </app-icon-button>
        <ng-template #emptyProposals>
          <p class="proposals-actions-card__empty">
            {{ 'MANAGE_VACATIONS.NO_PREFERENCES' | translate }}
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
